














































import { Component, Mixins } from "vue-property-decorator";
import { DateItem } from "../../../../domain/document/items";
import {
  IConfiguration,
} from "../../../../domain/configuration";
import { IObjectStyleReadable } from "../IObjectStyleReadable";
import { DateObjectStyleReader } from "../styleReaders";
import { DrawableItemEditorMixin } from "../mixins";
import { PropertyEditableMixin, DrawerPropertyEditableMixin, TextDrawerPropertyEditableMixin, PainterPropertyEditableMixin, EditPainterPropertyEditableMixin } from "./mixins";
import TextStyleEditor from "../../../drawing/TextStyleEditor.vue";
import FillStyleEditor from "../../../drawing/FillStyleEditor.vue";
import PrintBehaviorEditor from "./PrintBehaviorEditor.vue";
import QuotationEditor from "./QuotationEditor.vue";
import DateFormatEditor from "./DateFormatEditor.vue";
import TimeFormatEditor from "./TimeFormatEditor.vue";

@Component({
  components: {
    textStyleEditor: TextStyleEditor,
    fillStyleEditor: FillStyleEditor,
    printBehaviorEditor: PrintBehaviorEditor,
    quotationEditor: QuotationEditor,
    dateFormatEditor: DateFormatEditor,
    timeFormatEditor: TimeFormatEditor,
  },
})
export default class DatePropertyEditor extends Mixins<
  PropertyEditableMixin
  & DrawableItemEditorMixin
  & DrawerPropertyEditableMixin
  & TextDrawerPropertyEditableMixin
  & PainterPropertyEditableMixin
  & EditPainterPropertyEditableMixin
>(
  PropertyEditableMixin,
  DrawableItemEditorMixin,
  DrawerPropertyEditableMixin,
  TextDrawerPropertyEditableMixin,
  PainterPropertyEditableMixin,
  EditPainterPropertyEditableMixin,
) {
  get editStyleReader(): IObjectStyleReadable {
    const configuration = this.$store.getters.configuration as IConfiguration;
    return new DateObjectStyleReader(configuration.style.document.editor.objects.date);
  }

  editingSource: DateItem;
  writeProperty: (write: (source: DateItem) => void) => void;

  get isTime(): boolean {
    return (this.editingSource && this.editingSource.value)
      ? this.editingSource.value.isTime
      : undefined;
  }

  get format(): string {
    return this.editingSource
      ? this.editingSource.format
      : undefined;
  }

  set format(value: string) {
    this.writeProperty(s => s.format = value);
  }

  get isManualFormatSpecified(): boolean {
    return !!this.editingSource && !!this.editingSource.manualFormat;
  }
}
